import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    isOpen: Boolean,
    backdropClosable: Boolean
  }
 
  connect() {
    this.observeAttributesChange()

    if (this.isOpenValue) {
      this.open()
    }
  }

  disconnect() {
    this.observer?.disconnect()
    this.onModalClosed()
  }

  observeAttributesChange() {
    // Observer to detect changes in the 'open' and 'title' attributes
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          if (mutation.attributeName === 'open') {
            if (this.element.hasAttribute('open')) {
              this.onModalOpened()
            } else {
              this.onModalClosed()
            }
          }

          if (mutation.attributeName === 'title') {
            // Update the modal title
            const titleElement = this.element.querySelector('.js-modal-title')
            if (titleElement) {
              titleElement.textContent = this.element.getAttribute('title')
            }
          }
        }
      })
    })

    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ['open', 'title']
    })
  }

  open(modalId = '') {
    const modal = this.getModalById(modalId)
    if (!modal) return

    modal.showModal()
    this.onModalOpened()
  }

  onModalOpened() {
    this.isOpenValue = true
    document.body.style.overflow = 'hidden'
  }

  onModalClosed() {
    this.isOpenValue = false
    document.body.style.overflow = ''
  }

  getModalById(id = '') {
    if (!id) return null
    return document.getElementById(id)
  }

  preventCancel(event) {
    event.preventDefault()
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  close(modalId = '') {
    const modal = this.element.dataset.controller === 'component-modal' ? this.element : this.getModalById(modalId)
    if (!modal) return

    modal?.close()
    this.onModalClosed()
  }

}